import { ReactNode } from 'react'

import { observer } from 'mobx-react-lite'

import {
  calculateNights,
  formatDatesHeader,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan'

import { KyrgyzstanSearchParamsHeaderView } from '../search-params-header-view'

import { SearchParamsEditHintTour } from './search-params-edit-hint-tour'

interface SearchParamsHeaderProps {
  onGoBack: () => void
  actionRight?: ReactNode
  destination?: string
  onEditSearch?: () => void
}

export const SearchParamsHeader = observer(
  ({
    onGoBack,
    actionRight,
    destination,
    onEditSearch,
  }: SearchParamsHeaderProps) => {
    const { destinationDisplay, start_date, end_date, guestsCount } =
      kyrgyzstanSearchStore

    return (
      <>
        <KyrgyzstanSearchParamsHeaderView
          onGoBack={onGoBack}
          destination={destination || destinationDisplay}
          dates={formatDatesHeader(start_date, end_date)}
          nights={calculateNights(start_date, end_date)}
          guests={guestsCount}
          actionRight={actionRight}
          onEditSearch={onEditSearch}
        />
        {onEditSearch ? <SearchParamsEditHintTour /> : null}
      </>
    )
  },
)
